"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePathname = exports.PathnameProvider = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const PathnameContext = (0, react_1.createContext)(null);
const PathnameProvider = ({ pathname, children, }) => {
    const isLegacyLinkBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    if (!isLegacyLinkBehaviour && !pathname) {
        throw new Error("pathname cannot be undefined when using a custom LinkComponent");
    }
    return react_1.default.createElement(PathnameContext.Provider, { value: pathname !== null && pathname !== void 0 ? pathname : null }, children);
};
exports.PathnameProvider = PathnameProvider;
const usePathname = () => {
    const context = (0, react_1.useContext)(PathnameContext);
    if (context === undefined) {
        throw new Error("usePathname should be used within a PathnameProvider");
    }
    return context; // usePath should never be used if useLegacyLinkBehaviour returns true
};
exports.usePathname = usePathname;
//# sourceMappingURL=pathname.js.map